var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.can)?_c('fragment',[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }